import type { GalleryItem } from '../types/content'

// Afbeeldingen aangeleverd door de eigenaar, ter inspiratie:
// geen werk van klanten en geen bewijs van resultaten.
export const creations: GalleryItem[] = [
  {
    id: 'namen',
    motif: 'Persoonlijke namen',
    src: 'https://cdn.magicpatterns.com/uploads/s3CGL2uARcQLmjUpPHaMTs/nomi_personalizati.jpg',
    alt: 'De naam Laura in schrijfletters van roze punnikkoord op een ring versierd met bloemen van punnikkoord en een vlinder',
  },
  {
    id: 'kinderkamer',
    motif: 'Decoratie voor de kinderkamer',
    src: 'https://cdn.magicpatterns.com/uploads/pEKr4ptWbQxYa6izMc8hmg/decorazioni_camaretta.jpg',
    alt: 'Mobiel boven een wit wiegje met dierfiguren en letters van gekleurd punnikkoord',
  },
  {
    id: 'bedankjes',
    motif: 'Bedankjes',
    src: 'https://cdn.magicpatterns.com/uploads/82qnsauPEhpG48FxzqFqmj/bomboniere.jpg',
    alt: 'Hartvormige fotohouders van roze punnikkoord, waarvan er één een foto van babyvoetjes vasthoudt',
  },
  {
    id: 'sleutelhangers',
    motif: 'Sleutelhangers',
    src: 'https://cdn.magicpatterns.com/uploads/dL1DnsTU2pLUTAUtq2vCpr/portachiavi.jpg',
    alt: 'Sleutelhangers met een letter M van lila punnikkoord en een kwastje, verpakt op kraftkaartjes',
  },
  {
    id: 'bloemen',
    motif: 'Bloemen',
    src: 'https://cdn.magicpatterns.com/uploads/g7vbsCpivBtmH4FyCLGev4/Fiori_di_cordoncino.jpg',
    alt: 'Drie bloemen van geel, koraalrood en roze punnikkoord in een glazen potje op een boek',
  },
  {
    id: 'beginletters',
    motif: 'Decoratieve beginletters',
    src: 'https://cdn.magicpatterns.com/uploads/c2z6xxdW6EsstzapnsvKz3/Iniziali_decorative.jpg',
    alt: 'Letter E van zandkleurig punnikkoord, versierd met lila bloemen en groene blaadjes',
  },
]
